export const pressList = [
    {
        name: "ESPN / The Undefeated",
        title: "Featured Article + Network Show Appearance",
        image: "https://theundefeated.com/features/one-hope-for-the-next-generation-of-black-athletes/",
    },
    {
        name: "ATLANTA VOICE",
        title: "Motivator Kevin ‘Katalyst’ Carroll encourages everyone to chase their dreams ‘Red Rubber Ball’",
        image: "/images/press/atlanta-voice.jpg",
    },
    {
        name: "BLACKBERRY AD",
        title: "view image",
        image: "/images/press/blackberry-ad.jpg",
    },
    {
        name: "DELTA SKY MAG",
        title: "Play",
        image: "/images/press/delta-sky-mag.jpg",
    },
    {
        name: "ENTRSEKT",
        title: "An Advocate For Play",
        image: "/images/press/entrsekt.jpg",
    },
    {
        name: "ESPN",
        title: "Play Ball",
        image: "/images/press/espn.jpg",
    },
    {
        name: "KANSAS CITY STAR",
        title: "Playground games teach life lessons",
        image: "/images/press/kansas-city-star.jpg",
    },
    {
        name: "KIWANIS MAGAZINE",
        title: "April/May 2019 The Power of PLAY Issue",
        image: "/images/press/kiwanis-play.jpg",
    },
    {
        name: "MOTTO",
        title: "Rubber-Ball Power",
        image: "/images/press/motto-1.jpg",
    },
    {
        name: "NEWSWEEK",
        title: "The List",
        image: "/images/press/newsweek.jpg",
    },
    {
        name: "OREGON BUSINESS",
        title: "50 Great Leaders for Oregon",
        image: "/images/press/oregon-business.jpg",
    },
    {
        name: "THE OREGONIAN",
        title: "Project invites all to have a ball",
        image: "/images/press/the-oregonian-1.jpg",
    },
    {
        name: "THE OREGONIAN",
        title: "Seven Days of One Big Red Ball",
        image: "/images/press/the-oregonian-2.jpg",
    },
    {
        name: "THRIVE GLOBAL",
        title: "Living Fearlessly",
        image: "https://thriveglobal.com/stories/the-spirit-of-play/",
    },
    {
        name: "PHILADELPHIA DAILY NEWS",
        title: "His Secret to success? Follow the ‘red rubber ball’",
        image: "/images/press/philadelphia-daily-news.jpg",
    },
    {
        name: "POSITIVE THINKING",
        title: "“You changed my Life, Miz Lane”",
        image: "/images/press/positive-thinking.jpg",
    },
    {
        name: "SPARQ",
        title: "The Game Inside the Game",
        image: "/images/press/sparq-1.jpg",
    },
    {
        name: "SUCCESS",
        title: "Discover Your Creativity Practices to Unlock Your Thinking",
        image: "/images/press/success-1.jpg",
    },
    {
        name: "SUCCESS",
        title: "From Bill Gates to Tony Hsieh: 19 Seers Shaping the World",
        image: "/images/press/success-2.jpg",
    },
    {
        name: "TD Magazine",
        title: "An Interview with Kevin Carroll",
        image: "/images/press/td-magazine.jpg",
    },

];
